/* src/app/reducer.js */

import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { mapKeys, replace } from 'lodash';

import { Reducers } from '../modules';

export default combineReducers({
  router: routerReducer,
  ...mapKeys(Reducers, (v, k) => replace(k, 'Reducer', '')),
});



// WEBPACK FOOTER //
// ./src/config/reducer.js